export default "__VITE_ASSET__AtdQ_ymJ__"